import { Box, TextField, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

interface TemplateTextEditorProps {
  text: string;
  onVariableChange: (variables: Record<string, string>) => void;
}

const TemplateTextEditor: React.FC<TemplateTextEditorProps> = ({
  text,
  onVariableChange,
}) => {
  const theme = useTheme();
  const [variables, setVariables] = useState<Record<string, string>>({});

  useEffect(() => {
    const matches = text.match(/{{\d+}}/g) || [];
    const initialVariables: Record<string, string> = {};
    matches.forEach((match) => {
      if (!variables[match]) {
        initialVariables[match] = '';
      }
    });
    setVariables((prev) => ({ ...initialVariables, ...prev }));
  }, [text]);

  const handleVariableChange = (key: string, value: string) => {
    setVariables((prev) => {
      const updated = { ...prev, [key]: value };
      onVariableChange(updated);
      return updated;
    });
  };

  const renderText = () => {
    return text.split(/({{\d+}})/g).map((part, index) => {
      if (/^{{\d+}}$/.test(part)) {
        return (
          <TextField
            key={index}
            value={variables[part] || ''}
            onChange={(e) => handleVariableChange(part, e.target.value)}
            variant="outlined"
            size="small"
            sx={{
              margin: '0 4px',
              width: '80px',
              verticalAlign: 'middle',
              borderRadius: '8px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '700',
                fontFamily: 'AlmoniDL',
                padding: '2px 8px',
                height: '30px',
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.green.dark, // Используем цвет из темы
                  borderWidth: '2px',
                },
              },
              '& .MuiOutlinedInput-input': {
                padding: '4px 8px',
              },
            }}
          />
        );
      }
      return (
        <Typography
          key={index}
          dir="rtl"
          component="span"
          sx={{
            lineHeight: '2.2',
            fontSize: '16px',
            fontWeight: '700',
            fontFamily: 'AlmoniDL',
            display: 'inline',
          }}
        >
          {part}
        </Typography>
      );
    });
  };

  return (
    <Box
      sx={{
        boxShadow: '0px 0px 50px 0px rgba(0, 0, 0, 0.25)',
        width: '100%',
        maxHeight: '330px',
        overflowY: 'auto',
        py: '20px',
        px: '15px',
        borderRadius: '8px',
        backgroundColor: '#F9FAFB',
        boxSizing: 'border-box',
        textAlign: 'right',
      }}
    >
      <Typography
        component="div"
        sx={{
          fontSize: '16px',
          fontWeight: '700',
          fontFamily: 'AlmoniDL',
          textAlign: 'right',
          whiteSpace: 'pre-wrap',
        }}
      >
        {renderText()}
      </Typography>
    </Box>
  );
};

export default TemplateTextEditor;
